import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen.ts";

export const router = createRouter({ routeTree });

export function usePathname() {
	return router.parseLocation(router.history.location).pathname;
}

export function routerGoBack() {
	router.history.back();
}

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}
